module.exports = __webpack_public_path__ + "static/media/modelo_gestion_cuadro2.c800f6ec.png";